import { API_ROOT } from 'src/constants';
import Request, { setData, setMethod, setURL } from '../index';
import { getNamespaceName } from 'src/services/objects/namespaces';
import { eventPromiseRequest } from 'src/services/worklet';


export const createEventBridge = (data: any) =>
  Request<any>(
    setData(data),
    setURL(`${API_ROOT}/${getNamespaceName()}/eventbridge`),
    setMethod('POST')
  );

  export const createBatchEventBridge = (data: any) =>
  Request<any>(
    setData(data),
    setURL(`${API_ROOT}/${getNamespaceName()}/batch/eventbridge`),
    setMethod('POST')
  ); 
  
export const createRealTimeEventBridge = (data: any) =>{
    return eventPromiseRequest(data)
}
  

  